import React from "react";
import { useTranslation } from "react-i18next";
import { FaLifeRing, FaRocket } from "react-icons/fa";
import { FaDiagramProject, FaListCheck, FaScrewdriverWrench, FaChartSimple } from "react-icons/fa6";

const Step = ({ n, title, text }) => (
  <div className="approach-step">
    <div className="approach-step-num">{n}</div>
    <div>
      <div className="approach-step-title">{title}</div>
      <div className="approach-step-text">{text}</div>
    </div>
  </div>
);

const CALLOUT_ICONS = [FaDiagramProject, FaScrewdriverWrench, FaListCheck, FaChartSimple];

export default function OperationalApproach() {
  const { t } = useTranslation();
  const stabilizeSteps = t('approach.stabilize.steps', { returnObjects: true });
  const buildSteps     = t('approach.build.steps',     { returnObjects: true });
  const calloutItems   = t('approach.callout.items',   { returnObjects: true });

  return (
    <section id="approach" className="approach-section">
      <div className="container py-5">
        <div className="text-center mb-4">
          <h2>{t('approach.heading')}</h2>
          <p className="text-muted mb-0">{t('approach.description')}</p>
        </div>

        <div className="approach-grid">
          <div className="approach-card">
            <div className="approach-title-row">
              <FaLifeRing className="approach-title-icon" aria-hidden="true" />
              <h3 className="approach-card-title">{t('approach.stabilize.title')}</h3>
            </div>
            <p className="text-muted mb-3">{t('approach.stabilize.intro')}</p>
            {Array.isArray(stabilizeSteps) && stabilizeSteps.map((s, i) => (
              <Step key={i} n={i + 1} title={s.title} text={s.text} />
            ))}
          </div>

          <div className="approach-card accent">
            <div className="approach-title-row">
              <FaRocket className="approach-title-icon" aria-hidden="true" />
              <h3 className="approach-card-title">{t('approach.build.title')}</h3>
            </div>
            <p className="text-muted mb-3">{t('approach.build.intro')}</p>
            {Array.isArray(buildSteps) && buildSteps.map((s, i) => (
              <Step key={i} n={i + 1} title={s.title} text={s.text} />
            ))}
          </div>
        </div>

        <div className="approach-callout">
          <div className="callout-title-row">
            <div className="callout-title">{t('approach.callout.title')}</div>
          </div>
          <div className="callout-grid">
            {Array.isArray(calloutItems) && calloutItems.map((item, i) => {
              const Icon = CALLOUT_ICONS[i];
              return (
                <div key={i}>
                  {Icon && <Icon className="callout-title-icon" aria-hidden="true" />}
                  {item}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
